'use client';
import { LazyMotion, m as motion } from 'framer-motion';
import LinkWrapper from '../link-wrapper/link-wrapper';
import classNames from 'classnames';
import { PageContentTypes } from '@fm-nx/constants';
const loadFeatures = () => import('../__constants__/framer-features').then((res) => res.default);

type ButtonDisplayPropTypes = {
    text: string;
    buttonType?: 'solid' | 'outline-dark' | 'outline-white';
    // linked to slug of entry
    linkSlug?: string;
    pageType?: keyof typeof PageContentTypes;
    linkPath?: string;
};

export const ButtonDisplay = (props: ButtonDisplayPropTypes) => {
    const { linkSlug, pageType, linkPath } = props;
    // const { track, page, identify } = useNinetailed();
    const { text, buttonType = 'solid' } = props;
    const buttonClasses = classNames({
        'btn-solid': buttonType === 'solid',
        'btn-outline-dark': buttonType === 'outline-dark',
        'btn-outline-white': buttonType === 'outline-white',
    });

    return (
        <LinkWrapper
            pageType={pageType}
            slug={linkSlug}
            href={linkPath ? linkPath : undefined}
            // onClick={() => {
            //     track('CTA Button Click');
            // }}
        >
            <LazyMotion features={loadFeatures}>
                <motion.span className={`btn ${buttonClasses}`}>
                    <span className="pointer-events-none">{text}</span>
                </motion.span>
            </LazyMotion>
        </LinkWrapper>
    );
};

export default ButtonDisplay;
